import React from 'react'
import { IndexLink, Link } from 'react-router'
import PropTypes from 'prop-types'
import './CoreLayout.scss'

export const CoreLayout = ({ children }) => (
  <div id="coreLayout" className='text-center'>
    <div>
      {children}
    </div>
  </div>
)
CoreLayout.propTypes = {
  children: PropTypes.node,
}

export default CoreLayout



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js